// extracted by mini-css-extract-plugin
export default {"button":"PFwgU4rwjWQzqwAblm4X"};